import { Container, Stack, Button, Typography, Card, Box, Grid } from "@mui/material";
import { useAppSelector } from "Hooks/useRedux";

import DeveloperImage from "Assets/developer.svg";
import PaypalImage from "Assets/paypal.svg";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

interface IItem {
  id: number;
  title: string;
  features: string[];
  price?: string;
  image: string;
  color: string;
  comingSoon?: boolean;
}

const ITEMS: IItem[] = [
  {
    id: 1,
    title: "توسعه دهندگان",
    features: ["Android Studio", "Figma", "و ..."],
    image: DeveloperImage,
    color: "#357FFE",
  },
  {
    id: 2,
    title: "بازار های مالــی",
    features: ["یک کاربره", "پی‌پال", "ویزا کارت", "و ..."],
    price: "۶۹،۰۰۰",
    image: PaypalImage,
    color: "#FF0541",
    comingSoon: true,
  },
];

export default function Subscription() {
  const { isLoggedIn } = useAppSelector((state) => state.auth);

  const handleShowToast = () => {
    if (isLoggedIn) {
      toast.success("این حالت به صورت پیش فرض برای شما فعال است");
    }
  };

  return (
    <Container maxWidth="md">
      <Grid container columnSpacing={5} rowGap={3}>
        {ITEMS.map((item) => {
          return (
            <Grid item xs={12} md={6}>
              <Card sx={{ p: 3, height: "100%", position: "relative", overflow: "hidden" }}>
                {item.comingSoon && (
                  <Box
                    sx={{
                      width: "100%",
                      height: "100%",
                      position: "absolute",
                      top: "0",
                      left: "0",
                      zIndex: 100,
                      display: "grid",
                      placeItems: "center",
                      bgcolor: "rgba(124, 113, 255, 0.6)",
                      backdropFilter: "blur(1px)",
                      color: "#fff",
                    }}
                  >
                    <Typography variant="h4" fontWeight={600}>
                      بزودی ...
                    </Typography>
                  </Box>
                )}

                <Box sx={{ position: "absolute", bottom: "-40px", right: "-60px", width: "300px", opacity: 0.06 }}>
                  <img src={item.image} width="100%" />
                </Box>

                <Stack alignItems="center" justifyContent="center" spacing={3} sx={{ height: "100%" }}>
                  <img src={item.image} height="120px" />

                  <Typography variant="h5" fontWeight="700" sx={{ color: item.color }}>
                    {item.title}
                  </Typography>

                  {!item.comingSoon && (
                    <>
                      <Stack spacing={1} alignItems="center">
                        <Typography sx={{ color: "text.secondary" }}>مناسب برای</Typography>

                        {item.features.map((feature) => (
                          <Typography fontWeight="600" variant="h5">
                            {feature}
                          </Typography>
                        ))}
                      </Stack>
                      <Link to={isLoggedIn ? "" : "/register"}>
                        <Button
                          onClick={handleShowToast}
                          variant="contained"
                          size="large"
                          sx={{
                            py: 1.5,
                            minWidth: "200px",
                            bgcolor: item.color,
                            "&:hover": {
                              bgcolor: item.color,
                            },
                          }}
                        >
                          {isLoggedIn ? "فعال" : "فعالسازی"}
                        </Button>
                      </Link>
                    </>
                  )}
                </Stack>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Container>
  );
}
